require('../scss/main.scss');

const $ = require("jquery");
window.jQuery = $;
window.$ = $;

require('bootstrap');
require("jquery-ui");
require('jquery-ui/ui/widgets/autocomplete.js');


const Kernel = require('./utils/Kernel');
window.Kernel = new Kernel();

// js du client
window.Kernel.registerComponent('BannerSlider', require('./components/BannerSlider').default);
window.Kernel.registerComponent('Calendar', require('./components/Calendar').default);
window.Kernel.registerComponent('CtaSlider', require('./components/CtaSlider').default);
window.Kernel.registerComponent('EventBlock', require('./components/EventBlock').default);
window.Kernel.registerComponent('GuaranteeSlider', require('./components/GuaranteeSlider').default);
window.Kernel.registerComponent('Header', require('./components/Header').default);
window.Kernel.registerComponent('NewsSlider', require('./components/NewsSlider').default);
window.Kernel.registerComponent('TestimonialSlider', require('./components/TestimonialSlider').default);

require('./../../../js/utils/component-list');

document.addEventListener("DOMContentLoaded", function() {
    window.Kernel.mountComponents($('html'));
});